import { render, staticRenderFns } from "./FenceGuardIcon.vue?vue&type=template&id=1206da08&"
import script from "./FenceGuardIcon.vue?vue&type=script&lang=js&"
export * from "./FenceGuardIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports